export class TopSearch {
    private dialog: HTMLDialogElement | null;
    private openButton: NodeListOf<HTMLButtonElement> | null;
    private closeButton: HTMLButtonElement | null;
    private input: HTMLInputElement | null;

    constructor() {
        this.dialog = document.getElementById('top-search-dialog') as HTMLDialogElement;
        this.openButton = document.querySelectorAll<HTMLButtonElement>('[id^="top-search-trigger-"]');
        this.closeButton = document.getElementById('top-search-close') as HTMLButtonElement;
        this.input = document.getElementById('search-form-input-nav') as HTMLInputElement;

        this.init();
    }

    private init(): void {
        if (!this.dialog || !this.openButton) {
            return;
        }

        this.openButton.forEach((button) => {
            button.addEventListener('click', () => {
                this.dialog?.showModal();
                this.onOpen();
            });
        });

        this.closeButton?.addEventListener('click', () => {
            this.dialog?.close();
        });

        this.dialog.addEventListener('click', (event) => {
            const rect = this.dialog!.getBoundingClientRect();
            const isInDialog =
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom;

            if (!isInDialog) {
                this.dialog?.close();
            }
        });

        this.dialog.addEventListener('close', () => {
            this.onClose();
        });

        this.dialog.addEventListener('cancel', () => {
            this.onClose();
        });
    }

    private onOpen(): void {
        document.body.classList.add('overflow-hidden');

        requestAnimationFrame(() => {
            this.input?.focus({ preventScroll: true });
        });
    }

    private onClose(): void {
        document.body.classList.remove('overflow-hidden');
    }
}
